import React from 'react'

function Shimmer() {
  return (
    <div className='shimmer-container flex flex-wrap'>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>
      <div className='shimmer-cards m-3 p-4 w-[200px] bg-gray-100 h-[420px] rounded-lg hover:bg-gray-200'></div>

    </div>
  )
}


export function RestaurantMenuShimmer() {
  return <div className='my-24'>
    <div className='w-6/12 bg-gray-100 shadow-lg p-7 mx-auto my-2 '></div>
    <div className='w-6/12 bg-gray-100 shadow-lg p-7 mx-auto my-2 '></div>
    <div className='w-6/12 bg-gray-100 shadow-lg p-7 mx-auto my-2 '></div>
    <div className='w-6/12 bg-gray-100 shadow-lg p-7 mx-auto my-2 '></div>
    <div className='w-6/12 bg-gray-100 shadow-lg p-7 mx-auto my-2 '></div>
    <div className='w-6/12 bg-gray-100 shadow-lg p-7 mx-auto my-2 '></div>
    <div className='w-6/12 bg-gray-100 shadow-lg p-7 mx-auto my-2 '></div>
   
    
  </div>
}

export default Shimmer